import React from "react";
import { Link } from "react-router-dom";
import SidebarNav from "../sidebar";
import Header from "../header";
const Settings = () => {
  return (
    <>
      <Header />
      <SidebarNav />
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">General Settings</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">General Settings</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-12">
                {/* General */}
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Adding new admin
                    </h4>
                  </div>
                  <div className="card-body">
                    <form action="#">
                      <div className="form-group">
                        <label>New User Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label>email</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label>password</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label>Profile image</label>
                        <input type="file" className="form-control" />
                        <small className="text-secondary">
                          Recommended image size is <b>150px x 150px</b>
                        </small>
                      </div>
                      <div className="form-group mb-0">
                        <label>Favicon</label>
                        <input type="file" className="form-control" />
                        <small className="text-secondary">
                          Recommended image size is <b>16px x 16px</b> or{" "}
                          <b>32px x 32px</b>
                        </small>
                        <br />
                        <small className="text-secondary">
                          Accepted formats : only png and ico
                        </small>
                      </div>
                    </form>
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
                {/* /General */}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* /Main Wrapper */}
      </>
    </>
  );
};
export default Settings;
